import React, {FC} from 'react';

import {PATH_TO_CART} from 'desktop/pages/checkout/constants/checkout';
import {miniCartDrawerEvent} from 'desktopMiniCart/analytic/analytic';
import {useHostDispatch} from 'hooks/hostHooks/hostHooks';

import s from './miniCartHeaderLogin.scss';

/**
 * MiniCartHeaderLogin component
 * @param {PropsType} props - data
 * @returns {JSX.Element} - MiniCartHeaderLogin
 */
export const MiniCartHeaderLogin: FC<{isLoggedIn: boolean}> = ({
    isLoggedIn,
}): JSX.Element | null => {
    const dispatch = useHostDispatch();

    const handleLoginClick = () => {
        dispatch({
            payload: {
                disableRedirect: false,
                redirectUrl: PATH_TO_CART,
                tab: 'login',
                visible: true,
            },
            type: 'AUTH_POPUP@SET_VISIBLE',
        });
        miniCartDrawerEvent('Login');
    };

    if (isLoggedIn) return null;

    return (
        <div className={s.wrapper}>
            <div className={s.guestText}>
                <button className={s.logInText} onClick={handleLoginClick} type="button">
                    Log in
                </button>{' '}
                to save your cart across all devices
            </div>
        </div>
    );
};
